export enum ExemptionType {
    REMOTE = 'REMOTE',
    OFFICE = 'OFFICE',
    COMMON = 'COMMON',
}